import type { FeatureFlag } from './feature-flag-types'

export const FeatureFlagName = {
  // ==========================================
  // Flags Permanentes
  // Precisam ser revisadas periodicamente para avaliar se ainda fazem sentido ou se devem ser removidas
  // ==========================================
  COMPANIES_WITH_CUSTOM_HELP_CENTER: {
    name: 'skillcustomer-companies-custom-help-center',
    defaultValue: []
  },
  COMPANIES_WITH_PROFILE_ASSESSMENT: {
    name: 'skillcustomer-companies-with-profile-assessment',
    defaultValue: false
  },
  USER_SPACE_ENABLED: {
    name: 'skillcustomer-user-space-enabled',
    defaultValue: false
  },

  // ==========================================
  // Novas flags devem ser adicionadas abaixo, seguindo a mesma estrutura dos objetos anteriores
  // ==========================================
  ENABLE_CAREER_MENTOR: {
    name: 'skill-customer-enable-career-mentor',
    defaultValue: false
  },
  ENABLE_PDI_RECOMMENDATIONS: {
    name: 'skill-customer-enable-pdi-recommendations',
    defaultValue: false
  },
  ENABLE_FIT_SCORE: {
    name: 'skill-customer-enable-fit-score',
    defaultValue: false
  },
  ENABLE_POST_FETCH_SKILL_RECOMMENDATIONS: {
    name: 'skill-customer-post-fetch-skill-recommendations',
    defaultValue: false
  },
  // Mesma chave lida pelo backend (FeatureFlagEnum.PRODUCT_INTEREST_WITHOUT_OFFER). Uma flag paralela
  // dessincronizaria os dois lados: com ela ligada só aqui, a PDV renderizaria o CTA de "avise-me" contra
  // um endpoint que ainda responde 409.
  ENABLE_PRODUCT_INTEREST_WITHOUT_OFFER: {
    name: 'skill-customer-web-enable-product-interest-without-offer',
    defaultValue: false
  },
  ENABLE_USER_LEARNING_PREFERENCES: {
    name: 'skill-customer-enable-user-learning-preferences',
    defaultValue: false
  },
  // Portão de lançamento do "Estude no app": a configuração `skill-lms-app` do parceiro diz se o
  // conteúdo dele roda no app, mas não impede que alguém a ligue antes de o app estar publicado nas
  // duas lojas.
  //
  // Cobre a feature inteira — o selo nos cards e no PDV, o banner de incentivo e o fluxo da tela de
  // inscrição. Com ela desligada, toda tela fica idêntica ao que é hoje: o selo do app não aparece,
  // os de recomendação seguem no lugar deles, o banner não é montado e a inscrição mantém a
  // ilustração, o número do pedido e a revisão dos passos.
  ENABLE_STUDY_IN_APP: {
    name: 'skill-portal-platform-web-enable-study-in-app',
    defaultValue: false
  }
} as const

/**
 * Type helper for TypeScript
 */
export type FeatureFlagNameType = typeof FeatureFlagName

/**
 * Helper to get all flags as array
 * Used internally for initialization and caching
 */
export const getAllFlags = (): FeatureFlag[] => Object.values(FeatureFlagName)
